import API from "../../Api";
import  {NEW_API} from '../../Api'
import {
  RestaurantMenuRequest,
  RestaurantsRequestParams,
  SubmitFeedbackDetail,
} from "./restaurantModels";
import { Store } from "../../configureStore";
import { encryptJson } from "../../utils/react-ec-utils";
// Lazy import to break the configureStore ↔ restaurantAPI circular dependency

import { USER_DETAILS, USER_ID } from "../../constants";
import { getCookie } from "../../../helper/cookieHelper";
import { createRequest } from "../../utils/hmac-utils";

const getUserDetailsFromCookie = () => getCookie(USER_DETAILS) || {};
const isDineInOrderType = (type: any) =>
  typeof type === "string" && type.toLowerCase().replace(/-/g, "") === "dinein";
// let Store: any;
// const getStore = () => {
//   if (!Store) Store = require("../../configureStore").Store;
//   return Store;
// };
const buildRestaurantContactPayload = (data: any) => {
  const userDetails = getUserDetailsFromCookie();

  return {
    ...data,
    emailId: data?.emailId ?? data?.email ?? userDetails?.email ?? "",
    mobileNo: data?.mobileNo ?? data?.mobilePhone ?? userDetails?.mobilePhone ?? "",
  };
};

// Get Restaurants
export function getRestaurants(locationParams: RestaurantsRequestParams) {
  const data = encryptJson(locationParams)
  return API({
    method: "post",
    url: "/api/customers/findMerchant/v2",
    data: {"data": data},
  });
}

// Get Restaurant Details
export function getRestaurantDetails(slugId: string) {  
  const encryptedData = encryptJson({ slug: slugId }) 
  return API({
    method: 'post',
    url: '/api/customers/locations/slug',
    data: { data: encryptedData },
  });
  // return API({
  //   method: "get",
  //   url: "/merchants/info/" + slugId,
  // });
}

//  Get Restaurant details using location Id
export function getRestaurantDetailsbyLocationId(locationId: string) {
  const encryptedData = encryptJson({ staffId: null, locationId: locationId })
  return API({
    method: 'post',
    url: '/api/customers/locations/id',
    data: { data: encryptedData },
  });

  // return API({
  //   method: "get",
  //   url: `/merchants/location/${locationId}/details`,
  // });
}

export function getRestaurantMenuDetailsByEventDate(details: RestaurantMenuRequest) {
  const eventMenuData: any = { eventSlug: details?.eventSlug, locationId: details?.locationId, orderType: details?.type }
  if (isDineInOrderType(details?.type)) {
    eventMenuData.menutype = "c";
  }
  const data = encryptJson(eventMenuData)
  return NEW_API({
    method: "post",

      //  url: `/api/customers/locations/event-order-menu`,
      //  data:{'data':data}
    url: `/api/v1/merchants/locations/event-order-menu/v2`,
      data: eventMenuData

  });
}

export function getRestaurantMenuDetailsByEventDate1(details: RestaurantMenuRequest) {
  const eventMenuData: any = { eventSlug: details?.eventSlug, locationId: details?.locationId, orderType: details?.type }
  if (isDineInOrderType(details?.type)) {
    eventMenuData.menutype = "c";
  }
  const data = encryptJson(eventMenuData)
  return API({
    method: "post",

       url: `/api/customers/locations/event-order-menu`,
       data:{'data':data}
    // url: `/api/v1/merchants/locations/event-order-menu/v2`,
    //   data:{ eventSlug: details?.eventSlug, locationId: details?.locationId, orderType: details?.type }

  });
}
export function getRestaurantMenuDetails(details: any) {
   const currentActivMenuType = (Store as any).getState().restaurant.currentActivMenuType;
   const resolvedType = details?.from =="s"?currentActivMenuType:details.type;

  const updatedDetails = {
    ...details,
    visibleTo: Array.isArray(details.visibleTo) ? details.visibleTo : [details.visibleTo],
    type: resolvedType,
    ...(isDineInOrderType(resolvedType) ? { menutype: "c" } : {}),
  };
  const data = encryptJson(updatedDetails);

  return NEW_API({
    method: "post",
    // url: "/api/customers/menu",
    //    data:{"data":data}
     url: "/api/v1/merchants/menu/v2",
 
    data:  updatedDetails ,
  });
}
export function getRestaurantMenuDetails1(details: any) {
  const currentActivMenuType = (Store as any).getState().restaurant.currentActivMenuType;
  const resolvedType = details?.from =="s"?currentActivMenuType:details.type;

  const updatedDetails = {
    ...details,
    visibleTo: Array.isArray(details.visibleTo) ? details.visibleTo : [details.visibleTo],
    type: resolvedType,
    ...(isDineInOrderType(resolvedType) ? { menutype: "c" } : {}),
  };
  const data = encryptJson(updatedDetails);

  return API({
    method: "post",
     url: "/api/customers/menu",
      data:{"data":data},
    // url: "/api/v1/merchants/menu/v2",
 
    // data:  updatedDetails ,
  });
}

export function getFeedbackDetails() {
  return API({
    method: "get",
    url: "/api/customers/fetch-feedback",
  });
}

export async function submitFeedback(SubmitFeedbackDetails: SubmitFeedbackDetail) {
  const userID = getCookie(USER_ID)
  const payload = {...SubmitFeedbackDetails, customerId:userID};
  return API({
    method: "post",
    url: "/api/customers/add-feedback/v2",
    data: payload,
  });
}

export function getmasterRestaurantHomePageDetails(slug: string) {
  const data=encryptJson({"slug":slug})
  return API({
    method: "post",
    url: `/api/customers/details/v2`,
    data:{'data': data}
  });
}

export function getRestaurantTableDetails(locationId: string) {
  let payload={"locationId":locationId}
  const data = encryptJson(payload);
  return API({
    method: "post",
    url: '/api/customers/locations/reservations/table-details',
    data:{'data': data}
  });
}

export function getSearchResult(
  lat: string,
  lng: string,
  keyword: string,
  page: number
) {
  return API({
    method: "get",
    url: `/search?text=${keyword}&page=${page}&size=25&latitude=${lat}&longitude=${lng}`,
  });
}

export function getExactSearchResult(
  lat: string,
  lng: string,
  keyword: string
) {
  return API({
    method: "get",
    url: `/search?text=${keyword}&isExactMatch=1&latitude=${lat}&longitude=${lng}`,
  });
}

//view address
export function viewDeliveryAddress() {
  const customerID = getCookie(USER_ID);
  const userDetails = getUserDetailsFromCookie();
  const payload = { customerId: customerID };
  // Don't make API call if customerID doesn't exist (e.g., after 403/401 or page refresh)
  if (!customerID) {
    return Promise.reject({ 
      response: { 
        status: 401, 
        data: { message: 'Customer ID not found' } 
      } 
    });
  }
  return API({
    method: "get",
    url: `/api/customers/order/fetch-address?customerId=${customerID}&emailId=${encodeURIComponent(userDetails?.email || "")}&mobileNo=${encodeURIComponent(userDetails?.mobilePhone || "")}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

//add delivery address
export async function addDeliveryAddress(data: any) {
  const userID = getCookie(USER_ID)
  const payload = {
    ...buildRestaurantContactPayload(data),
    customerId: userID,
  };
     const hmacRequest = await createRequest(payload);
  return API({
    method: "post",
    url: `/api/customers/order/save-address`,
    data: hmacRequest,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

//edit address
export  async function editDeliveryAddress(data: any) {
  const userID = getCookie(USER_ID)
  const addressId = data?.id
  const payload = {
    ...buildRestaurantContactPayload(data),
    customerId: userID,
  };
   const hmacRequest = await createRequest(payload);
  return API({
    method: "put",
    url: `/api/customers/order/update-address/${addressId}`,
    data: hmacRequest,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

//delete address
export function deleteDeliveryAddress(data: any) {
  const addressId = data
  return API({
    method: "delete",
    url: `/api/customers/order/remove-address/${addressId}`,
  });
}

export async function AddFav(data: any) {
  const userID = getCookie(USER_ID)
  const payload = {
    ...buildRestaurantContactPayload(data),
    customerId: userID,
  };
   const hmacRequest = await createRequest(payload);
  return API({
    method: "post",
    url: "/api/customers/add-favourites",
    data: hmacRequest,
  });
}

export async function removeFav(data: any) {
  const userID = getCookie(USER_ID)
  const contactPayload = buildRestaurantContactPayload(data);
  const { mobileNumber, ...safeContactPayload } = contactPayload || {};
  const payload = {
    ...safeContactPayload,
    customerId: userID,
  };
  return API({
    method: "delete",
    url: "/api/customers/remove-favourites",
    data: payload,
  });
}

export function getFav(data: any) {
  const userID = getCookie(USER_ID)
  const userDetails = getUserDetailsFromCookie();
  const emailId = data?.emailId ?? userDetails?.email ?? "";
  const mobileNo = data?.mobileNo ?? userDetails?.mobilePhone ?? "";

  return API({
    method: "get",
    url: `/api/customers/fetch-favourites?locationId=${data?.locationId}&customerId=${userID || data?.customerId}&emailId=${encodeURIComponent(emailId)}&mobileNo=${encodeURIComponent(mobileNo)}`,
  });
}

export function exploreMenu(data: any){
  return API({
    method: 'get',
    url: `/api/customers/locations/${data?.locationId}/menu?orderType=${data?.menuType}`
  })
}
//coupon api's
export function getCoupon(data: any) {
  return API({
    method: "get",
    url: `/coupon/getActiveCoupons?locationId=${data?.locationId}&orderType=${data?.orderType}&visibleTo=${data.visibleTo}&customerId=${data.customerId}`,
  });
}



export async function validateCoupon(data: any) {
  const payload = {
    customerId: data?.customerId ?? '',
    promoCode: data?.couponCode,
    locationId: data?.locationId,
  };
  // In logout flow there is no access token, so HMAC key is never derived and
  // createRequest throws. Fall back to the raw payload so the API is still
  // called (the backend validates the promo code without requiring auth).
  let requestData: any;
  try {
    requestData = await createRequest(payload);
  } catch {
    requestData = payload;
  }
  return API({
    method: 'post',
    url: '/api/customers/validateOffer',
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function redeemCoupon(data: any) {

  const payload={
  "customer_id": "",
  "location_id": "",
  "order_id": "",
  "order_amount":0.0,
  "offer_id": ""
}
  return API({
    method: "post",
    url: 'coupon/v2/redeemCoupon',
     data :payload
  });
}
